module.exports = __webpack_public_path__ + "img/meetsanta3.974e8b70.gif";